import ApiService from '../services/apiService';

const indexPensionFundsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/pension_funds', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const exportPensionFundRequest = ({ dispatch, params = {}, callback, successCallback }) =>
  ApiService.request('get', `/pension_funds/export.xlsx`, {
    dispatch,
    params,
    responseType: 'text',
    successCallback,
    callback
  });

export default indexPensionFundsRequest;
